import { render, staticRenderFns } from "./Reseller.vue?vue&type=template&id=0a2e0df0"
import script from "./Reseller.vue?vue&type=script&lang=js"
export * from "./Reseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports